import { ErrorTypes } from 'feedback-public-submission-ui/constants/ErrorConstants';
export const getSurveyConfigErrorType = (error, feedbackResponse, isParamsValid) => {
  if (!isParamsValid) {
    return ErrorTypes.INVALID_PARAMS;
  }
  return error || feedbackResponse.error || null;
};